import {types} from "mobx-state-tree";
import Notification from "../../../utils/Notification";

export const SimulatePreviewState = types.model('SimulatePreviewState', {
  simulatedLandingUrl: types.optional(types.string, ''),
  excludeUtmAndParams: types.optional(types.boolean, false),
}).volatile( self => ({
  iFrameRef: undefined,
  openWindow: undefined
})).actions(self => ({
  setSimulatedUrl(url) {
    self.simulatedLandingUrl = url
  },
  setIframeRef(ref) {
    self.iFrameRef = ref
  },
  setIframeError(value) {
    self.iframeError = value
  },
  copySimulatedLandingUrl() {
    navigator.clipboard.writeText(self.simulatedLandingUrl).then(() => {
      new Notification("success", "'" + self.simulatedLandingUrl + "' was copied to your clipboard.").send();
    });
  },
  setExcludeUtmAndParams(value) {
    self.excludeUtmAndParams = value
  },
  handleIframeLoad() {
    if (self.iFrameRef) {
      const hasContent =
        self.iFrameRef?.contentWindow &&
        self.iFrameRef?.contentWindow.length > 0;
      if (!hasContent) {
        new Notification()
          .setType("warning")
          .setMessage("Unable to load content. Opening in a new window...")
          .send();
        self.openNewWindow()
      }
    }
  },
  openNewWindow() {
    const width = 800;
    const height = 600;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;

    if (!self.openWindow || self.openWindow.closed) {
      self.openWindow = window.open(
        self.simulatedLandingUrl,
        '_blank',
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
      );
    } else {
      self.openWindow.location.href = self.simulatedLandingUrl;
      self.openWindow.focus();
    }
  }
}))
